import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AlertifyService } from './alertify.service';
import { StateVM, OperationResult } from '../models/ViewModels';
import { environment } from '../../environments/environment';
import { ErrorService } from '../interceptors/error.service';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  stateApi = `${environment.apiUrl}/State`;

  constructor(private http: HttpClient,
    private errorService: ErrorService,
    private alertify: AlertifyService) { }

  getAll() {
    return this.http.get(this.stateApi).pipe(
      map((response: OperationResult<StateVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          return null;
        }
      }));
  }

  getById(id: string) {
    const uri = `${this.stateApi}/GetByIdentifier?uuid=${id}`;
    return this.http.get(uri).pipe(
      map((response: OperationResult<StateVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }
}
